<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
          v-if="showAssignTechnology"
          class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen"
      >
        <form
            @submit.prevent="create"
            class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/3 w-full"
        >
          <transition name="fade">
            <div
                v-if="loading"
                class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Assign Technology</p>
            <img
                class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                src="@/assets/icons/cross-white.png"
                @click="close()"
            />
          </div>
          <transition name="fade">
            <div
                v-if="create_error"
                class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="px-4 py-2">
            <div class="text-sm">
              <label class="block pb-1">Technology Type</label>
              <select
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                  v-model="technology_type"
              ><option value="" disabled>Select an Technology</option>
                <option v-for="(technology, index) in technologies" :key="index">
                  {{ technology }}
                </option>
              </select>
            </div>
          </div>
          <div class="px-4 py-2" v-if="technology_type==='Hardware'">
            <div class="text-sm">
              <label class="block pb-1">Assets</label>
              <select
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                  v-model="technology_type"
              >
                <option v-for="(technology, index) in technologies" :key="index">
                  {{ technology }}
                </option>
              </select>
            </div>
          </div>
          <div class="px-4 py-2">
            <div class="text-sm">
              <label class="block pb-1">Employee Responsible</label>
              <select
                  required
                  class="p-2 bg-gray-200 rounded-full w-full"
                  v-model="selectedEmployee"
              >
                <option value="" disabled>Select an Employee</option>
                <option
                    v-for="employee in this.getEmployees"
                    :key="employee.EmployeeId"
                    :value="employee.EmployeeId"
                >
                  {{  decryptDataLocal(employee.Fullname , decryptionKey)}}
                </option>
              </select>
            </div>
          </div>
          <div class="px-4 py-2">
            <label>Description</label>
            <textarea
                v-model="info.Description"
                class="p-1 bg-gray-200 rounded w-full"
                cols="5"
                rows="3"
            ></textarea>
          </div>
          <div class="flex justify-end p-5">
            <button
                type="submit"
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
    <!-- <leave-date-picker></leave-date-picker> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import decryptData from "@/utils/decrypt";

export default {
  name: "assignTechnologies",
  props: ["showAssignTechnology"],
  components: {
    Loader,
  },
  data() {
    return {
      create_error: null,
      loading: false,
      technology_type:'',
      decryptionKey: '',
      decryptDataLocal: '',
      selectedEmployee: "",
      selectedAsset:'',
      issuedTechnologies:[],
      assets:[],
      technologies:['Hardware', 'Software', 'Access Control'],
      info: {
        Description: null,
      },
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentEmployeeId", "getEmployees"]),

  },
  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.getIssuedTechnologies()
  },
  watch: {},
  methods: {
    close() {
      this.$emit("close");
      (this.info = {
        Description: null,
      });
    },
    getAssetTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .get(
              `${this.getOrganization}/asset/${this.$ApiVersion}/request`,
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.assets = response.data.Data;
                }
              },
              () => {
                this.loading = false;
              }
          );
    },
    getIssuedTechnologies(){
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .get(
              `${this.getOrganization}/asset/${this.$ApiVersion}/request`,
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.issuedTechnologies = response.data.Data;
                  //console.log(this.ClaimTypes)
                }
              },
              () => {
                this.loading = false;
              }
          );
    },
    create() {
      const formData = new FormData();
      formData.append("AssetID", this.selectedAsset);
      formData.append("Description", this.info.Description);
      formData.append("EmployeeResponsible", this.selectedEmployee);
      formData.append("TechnologyType", this.technology_type);

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
          .post(
              `${this.getOrganization}/employee/claim/${this.$ApiVersion}/create`,
              formData,
              options
          )
          .then(
              (response) => {
                this.loading = false;
                if (response.data.StatusCode == 200) {
                  this.info = {
                    Description: "",
                  };
                } else {
                  this.create_error = response.data.StatusMessage;
                }
              },
              (error) => {
                this.loading = false;
                this.create_error = error.message;
              }
          );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
